import { Concierge } from './concierge.types';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ConciergeService {
	private conciergeUrl = 'api/concierges';

	constructor(private http: HttpClient) { }

	getConcierges(): Promise<Concierge[]> {
		return this.http.get<Concierge[]>(this.conciergeUrl)
			.toPromise();
	}
}
